/**
 * A HUD button's real icon (story `q-hud-panel-button-icons`, owner 2026-10-29: the bottom-right
 * "Ch" read as the Charge ability, but it was the Character panel). Every launcher, dock, menu and
 * window button draws served icon art, never a two-letter text label. The art is DATA: one SVG per
 * id at `assets/ui/hud-icons/<id>.svg`, L2 Soft Relief like the ability icons (AbilityIcon.tsx,
 * AA-039 / TGC-UI-010). A panel's icon id IS its panel id (panels/index.tsx); the other buttons
 * name theirs at the call site (`menu`, `map`, `chat`, `leave`, `end-demo`, `dodge`, `close`).
 * abilityIcon.test.tsx fails when a HUD button of any kind renders a bare text label, or when an
 * id in use has no SVG.
 *
 * The image is decorative (`alt=""`): the button carries the accessible name (`aria-label`, and a
 * `title` tooltip on desktop).
 */

/** Served directory of the HUD button icons, relative to the app base. */
export const HUD_ICON_DIR = 'assets/ui/hud-icons';

/** The served URL of a HUD button's icon. */
export function hudIconUrl(id: string): string {
  const base = (import.meta as { env?: { BASE_URL?: string } }).env?.BASE_URL ?? '/';
  return `${base.replace(/\/+$/, '')}/${HUD_ICON_DIR}/${encodeURIComponent(id)}.svg`;
}

export function HudIcon({ id, size = 24 }: { id: string; size?: number }): JSX.Element {
  return (
    <img
      className="hud-icon"
      src={hudIconUrl(id)}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      style={{ width: size, height: size }}
      draggable={false}
      data-hud-icon={id}
    />
  );
}
